import i18n from '../translations'
import { LOCALES } from '../Constants';

export default class LocaleHelper {
  static getLocaleOptions(): { value: string, label: string }[] {
    return LOCALES.map(locale => ({ label: i18n.t(`Locales::${locale}`), value: locale }))
  }
}